if (!customElements.get("m-gallery")) {
  class MGallery extends HTMLElement {
    constructor() {
      super();

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = parseInt(this.dataset.items) || 4;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.slideContainer = this.querySelector(".swiper-container");
    }

    connectedCallback() {
      this.lastActive = null;
      if (this.enableSlider) this.initSlider();
    }

    initSlider() {
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = this.querySelector(".swiper-wrapper").childElementCount;
      let __this = this;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1,
        spaceBetween: parseInt(getComputedStyle(this).getPropertyValue("--column-gap-mobile")) || 10,
        navigation: this.showNavigation,
        loop: slideItemsLength > this.items,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          480: {
            slidesPerView: 2,
            spaceBetween: parseInt(getComputedStyle(this).getPropertyValue("--column-gap-mobile")) || 10,
          },
          768: {
            slidesPerView: Math.max(2, this.items - 2),
            spaceBetween: parseInt(getComputedStyle(this).getPropertyValue("--column-gap")) || 30,
          },
          1024: {
            slidesPerView: Math.max(2, this.items - 1),
            spaceBetween: parseInt(getComputedStyle(this).getPropertyValue("--column-gap")) || 30,
          },
          1280: {
            slidesPerView: this.items,
            spaceBetween: parseInt(getComputedStyle(this).getPropertyValue("--column-gap")) || 30,
          },
        },
        on: {
          init: function () {
            if (__this.lastActive !== null) {
              this.slideToLoop(__this.lastActive);
            }
            setTimeout(() => {
              if (controlsContainer) {
                const firstItem = __this.querySelector(".m-gallery__media");
                if (firstItem) {
                  const itemHeight = firstItem.clientHeight;
                  controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");
                }

                if (prevButton) prevButton.classList.remove("m:hidden");
                if (nextButton) nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (this.slider && this.showNavigation) {
        if (prevButton) prevButton.addEventListener("click", () => this.slider.slidePrev());
        if (nextButton) nextButton.addEventListener("click", () => this.slider.slideNext());
      }

      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onBlockSelect(e) {
      const block = e.target;
      if (!this.contains(block)) return;
      
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-gallery", MGallery);
}
